import historySchema from './history.schema';
import * as historyRuleset from './history.ruleset';
import historyApi from './history.api';
import { ReplicantModuleState } from '../../utils';
import { Immutable } from '@play-co/replicant';

/**
 * This module save history of species death and duo events
 *
 * Usage:
 *
 * - Adding death record:
 * History.api.addDeathRecord(state, { ... });
 *
 * - Add duo record:
 * History.api.addPlayerDuoRecord(state, { ... current player information data ... });
 * api.postMessage.addFriendDuoRecord({ ... friend information about duo event ... });
 *
 * - Get get all history records for current user:
 * const history = History.api.getHistory()
 */

export type History = typeof History;
// eslint-disable-next-line no-redeclare
export namespace History {
  export const ruleset = historyRuleset;
  export const schema = historySchema;
  export const api = historyApi;

  export type MutableState = ReplicantModuleState<History>;
  export type State = Immutable<MutableState>;
}
